"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = exports.MESSAGE_VARIANTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Flex = require("../Flex");
var _Text = require("../Text");
var _excluded = ["children", "title", "variant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MESSAGE_VARIANTS = {
  default: {
    backgroundColor: "black5",
    color: "black100"
  },
  info: {
    backgroundColor: "blue10",
    color: "blue100"
  },
  success: {
    backgroundColor: "green10",
    color: "green150"
  },
  alert: {
    backgroundColor: "orange10",
    color: "orange150"
  },
  warning: {
    backgroundColor: "yellow10",
    color: "yellow150"
  },
  error: {
    backgroundColor: "red10",
    color: "red100"
  }
};
exports.MESSAGE_VARIANTS = MESSAGE_VARIANTS;
var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Message__Container",
  componentId: "sc-t49v7v-0"
})(["", " flex-direction:column;"], (0, _styledSystem.variant)({
  variants: MESSAGE_VARIANTS
}));

/**
 * `Message` is used for in-line communication. These should fill the allotted
 * container or space they are placed and key for temporal messages and
 * comments within flows. Additionally, they can be used to highlight particular
 * messaging within a specific section of a page or screen.
 */
var Message = function Message(_ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var color = variant === "default" ? "black60" : "black100";
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    p: 2,
    variant: variant
  }, rest), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display",
    color: "currentColor"
  }, title), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "sm-display",
    color: color
  }, children));
};
exports.Message = Message;
Message.displayName = "Message";
//# sourceMappingURL=Message.js.map